import { render, staticRenderFns } from "./SavingsPockets.vue?vue&type=template&id=29c481e6&scoped=true&"
import script from "./SavingsPockets.vue?vue&type=script&lang=js&"
export * from "./SavingsPockets.vue?vue&type=script&lang=js&"
import style0 from "./SavingsPockets.vue?vue&type=style&index=0&id=29c481e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c481e6",
  null
  
)

export default component.exports